import React, { useMemo } from 'react';

import { useIntl } from 'react-intl';

import LinkIcon from '@atlaskit/icon/core/link';
import type { SideNavModalItem } from '@atlassian/conversation-assistant-ui-components/ui/side-nav-modal/modal';

import { messages } from './messages';
import { SharedChatsContent } from './SharedChatsContent';

export const useSharedChatsSideNavModalItem = (): SideNavModalItem => {
	const { formatMessage } = useIntl();

	return useMemo(
		() => ({
			id: 'shared-chats',
			label: formatMessage(messages.sideNavLabel),
			searchLabel: formatMessage(messages.sideNavLabel),
			icon: <LinkIcon label="" />,
			contentHeader: formatMessage(messages.contentHeader),
			content: () => <SharedChatsContent />,
		}),
		[formatMessage],
	);
};
